module.exports = __webpack_public_path__ + "img/btn_01_login.1560234b.png";